/** Helpers for the hosted-agent invoice card (#3039). */

/** The current month first, then the previous `count - 1` months, as "YYYY-MM". */
export function recentInvoiceMonths(now: Date, count = 6): string[] {
  const months: string[] = []
  const cursor = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1))
  for (let index = 0; index < count; index += 1) {
    months.push(`${cursor.getUTCFullYear()}-${String(cursor.getUTCMonth() + 1).padStart(2, "0")}`)
    cursor.setUTCMonth(cursor.getUTCMonth() - 1)
  }
  return months
}

/** Filename the CSV download is saved as — matches the backend's Content-Disposition. */
export function invoiceCsvFilename(month: string): string {
  return `hosted-agents-${month}.csv`
}

/** Save a blob through a transient anchor (the same pattern the tender trace export uses). */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  setTimeout(() => {
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }, 100)
}

/**
 * Whether the Costs view offers the hosted-agent invoice card.
 *
 * The invoice endpoint sits behind `require_admin_capability("hosted_agents")`,
 * so a customer admin without that capability only ever got a 403 error card.
 * Offered when hosted agents exist on this deployment AND the viewer manages
 * them: a platform admin, or a customer admin delegated `hosted_agents:
 * manage`. While a platform admin previews a customer admin, the previewed
 * delegation decides, never the viewer's own role.
 */
export function canSeeHostedAgentInvoice({
  hostedAgentsEnabled,
  isPlatformAdmin,
  adminCapabilities,
  previewModes,
}: {
  hostedAgentsEnabled: boolean
  isPlatformAdmin: boolean
  adminCapabilities: Record<string, string> | undefined
  previewModes?: Record<string, string>
}): boolean {
  if (!hostedAgentsEnabled) return false
  if (previewModes) return previewModes["hosted_agents"] === "manage"
  return isPlatformAdmin || adminCapabilities?.["hosted_agents"] === "manage"
}
